import styled from 'styled-components';

import { ContentBanner as ContentBannerComponent } from '@xingternal/banner';
import { mediaConfined, mediaWide } from '@xingternal/layout-tokens';
import { cornerRadiusL, spaceL, spaceM, spaceS, spaceXL, spaceXXL } from '@xingternal/tokens';
import { BodyCopy as BodyCopyComponent, Headline as HeadlineComponent } from '@xingternal/typography';

export const ContentBanner = styled(ContentBannerComponent)`
  align-items: normal;
  border-radius: ${cornerRadiusL};
  flex-direction: column;
  padding: ${spaceXL} ${spaceL};
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media ${mediaConfined} {
    flex-direction: row;
  }
`;

export const InfoContainer = styled.div`
  flex: 1;
`;

export const Headline = styled(HeadlineComponent)`
  margin-bottom: ${spaceM};
`;

export const RecruiterInfoContainer = styled.div`
  display: flex;
  gap: ${spaceXXL};
  margin-bottom: ${spaceL};

  @media ${mediaWide} {
    margin-bottom: 0;
  }
`;

export const RecruiterInfoCard = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  @media ${mediaWide} {
    align-items: center;
    flex-direction: row;
  }
`;

export const RecruiterInfoCardCopy = styled(BodyCopyComponent)`
  margin: 0;

  @media ${mediaWide} {
    margin-left: ${spaceS};
  }
`;

export const ButtonContainer = styled.div`
  align-items: center;
  display: flex;

  @media ${mediaConfined} {
    flex: 0.5;
    justify-content: flex-end;
  }
`;
